import {
  COMPANY_BILLING_ROUTE,
  COMPANY_EVENT_DEFAULTS_ROUTE,
  COMPANY_INFO_ROUTE,
  COMPANY_INTEGRATIONS_ROUTE,
  COMPANY_VENUES_ROUTE,
  COMPANY_WIDGET_ROUTE,
  USERS_ROUTE,
} from '@constants/routes';
import { TFunction } from 'i18next';

import {
  BILLING_PAGE_ID,
  EVENT_DEFAULTS_PAGE_ID,
  INFO_PAGE_ID,
  INTEGRATIONS_PAGE_ID,
  USERS_PAGE_ID,
  VENUES_PAGE_ID,
  WIDGET_PAGE_ID,
} from '../constants';

export const getCompanyTabs = ({
  companyId,
  clubSlug,
  isEnabledCompanyInfo,
  isEnabledEventDefaults,
  isEnabledUsers,
  isEnabledWidget,
  isVenueSettingsActive = false,
  t,
}: {
  companyId: string;
  clubSlug: string;
  t: TFunction;
  isEnabledCompanyInfo: boolean;
  isEnabledEventDefaults: boolean;
  isEnabledUsers: boolean;
  isEnabledWidget: boolean;
  isVenueSettingsActive?: boolean;
}) => {
  const infoTab = {
    id: INFO_PAGE_ID,
    name: t('companySettings:publicNameSectionTitle'),
    href: COMPANY_INFO_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const eventDefaultsTab = {
    id: EVENT_DEFAULTS_PAGE_ID,
    name: t('menu:events'),
    href: COMPANY_EVENT_DEFAULTS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const usersTab = {
    id: USERS_PAGE_ID,
    name: t('userManagement:tabUsers'),
    href: USERS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const integrationsTab = {
    id: INTEGRATIONS_PAGE_ID,
    name: t('companyIntegrations:navigationTabLabel'),
    href: COMPANY_INTEGRATIONS_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const widgetTab = {
    id: WIDGET_PAGE_ID,
    name: t('companyWidget:navigationTabLabel'),
    href: COMPANY_WIDGET_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const venuesTab = {
    id: VENUES_PAGE_ID,
    name: t('companySettings:venuesNavigationTabLabel'),
    href: COMPANY_VENUES_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const billingTab = {
    id: BILLING_PAGE_ID,
    name: t('companySettings:billingNavigationTabLabel'),
    href: COMPANY_BILLING_ROUTE.replace(':companyId', companyId).replace(':clubSlug', clubSlug),
  };

  const tabs: (typeof infoTab)[] = [];

  if (isEnabledCompanyInfo) {
    tabs.push(infoTab);
    if (isVenueSettingsActive) {
      tabs.push(venuesTab);
    }
    if (isEnabledEventDefaults) {
      tabs.push(eventDefaultsTab);
    }
    tabs.push(integrationsTab);
    if (isEnabledUsers) {
      tabs.push(usersTab);
    }
    if (isEnabledWidget) {
      tabs.push(widgetTab);
    }
    tabs.push(billingTab);
  }

  return tabs;
};
